// api protocol
const axios = require('axios')
const config = require('../api/config.js')
const VueCookie = require('vue-cookies')
// seting axios
// axios.defaults.headers.common = {}
// axios.defaults.headers.common.accept = 'application/json'
// axios.defaults.headers.Authorization = 'Bearer ' + VueCookies.VueCookies.get('user')
//
// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
// axios.defaults.headers.common['Access-Control-Allow-Methods'] = 'GET,PUT,POST,DELETE,PATCH,OPTIONS'
// axios.defaults.headers.common['Access-Control-Allow-Header'] = 'Content-Type, Authorization'
// axios.defaults.headers['Content-Type'] = 'application/jsoncharset=UTF-8'
// axios.defaults.data = 'Bearer ' + VueCookies.VueCookies.get('user')
//

// initialize response
const response = {}

// calling api
response.call = (path, method, data, headers = config.defaultHeader, url = config.apiUrl) => {
  return new Promise((resolve, reject) => {
    const options = {
      url: url + path + '?token=' + VueCookie.get('user'),
      method,
      headers: config.headers,
      data: method !== 'get' ? data : {},
      params: method === 'get' ? data : {}
    }
    return axios(options).then((res) => {
      return resolve(res.data)
    }).catch(function (error) {
      return reject(error)
    })
  })
}

// export response
module.exports = response
